import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.749 4.74v2.63h.75a.749.749 0 0 1 .75.75V11a.749.749 0 0 1-.75.75h-3a.755.755 0 0 1-.75-.75V8.12a.755.755 0 0 1 .75-.75h.75V4.74h-6.14v8.51h.25a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1 0-1.5h.25V4.74h-1.6a.748.748 0 0 1-.29-1.44l1.89-.78V2a.75.75 0 0 1 1.5 0v.32l8.97.92a.757.757 0 0 1 .67.79.748.748 0 0 1-.75.71Z';
const draw24px =
  'M22.23,4.33,6.64,2.72V2.08a.75.75,0,0,0-1.5,0v.83L1.57,4.39a.75.75,0,0,0,.28,1.44H5.14V21.25H3.79a.75.75,0,1,0,0,1.5H8a.75.75,0,0,0,0-1.5H6.64V5.83H17.16v6.28H15.4a.76.76,0,0,0-.75.75V17a.75.75,0,0,0,.75.75h5a.75.75,0,0,0,.75-.75V12.86a.76.76,0,0,0-.75-.75H18.66V5.83h3.49a.75.75,0,0,0,.08-1.5Zm-2.55,9.28v2.63H16.15V13.61Zm-1.77-.77v-.73';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CraneIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'crane'),
) as IconWithRender;

CraneIcon.displayName = 'CraneIcon';
CraneIcon.propTypes = Icon.propTypes;
CraneIcon.renderIcon = (props) => <CraneIcon {...props} />;
export default CraneIcon;
